import script from "./AddProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProfile.vue?vue&type=script&setup=true&lang=js"

import "./AddProfile.vue?vue&type=style&index=0&id=2225782b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2225782b"]])

export default __exports__